@if (loading()) {
  <div class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading people...</p>
  </div>
} @else if (rows().length > 0) {
  <table mat-table [dataSource]="rows()" matSort class="people-table">

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let row">
        <a class="person-link" (click)="navigateToPerson(row.person); $event.stopPropagation()">
          {{ row.person.fullName || ((row.person.firstName || '') + ' ' + (row.person.lastName || '')) || 'Unknown' }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
      <td mat-cell *matCellDef="let row">{{ row.person.title || '' }}</td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
      <td mat-cell *matCellDef="let row">{{ row.person.email || '' }}</td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone</th>
      <td mat-cell *matCellDef="let row">{{ row.person.officePhone || row.person.primaryPhone || row.person.mobilePhone || '' }}</td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Company</th>
      <td mat-cell *matCellDef="let row">{{ row.person.primaryVendorFriendlyName || '' }}</td>
    </ng-container>

    <ng-container matColumnDef="source">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Source Contract</th>
      <td mat-cell *matCellDef="let row">
        <mat-chip>{{ row.source }}</mat-chip>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        class="people-row"
        (click)="navigateToPerson(row.person)"></tr>
  </table>
} @else {
  <mat-card class="empty-state">
    <mat-card-content>
      <mat-icon>person</mat-icon>
      <p>No people associated with this entity's contracts</p>
    </mat-card-content>
  </mat-card>
}
